import { useCallback, useEffect, useMemo, useState } from 'react'
import { UserService } from '../services/users'
import { compareRosterValue } from '../utils/gradeClass'

/**
 * 学校の生徒の実データから作る学年・クラスの選択肢（database/115 の関数でDB側DISTINCT）。
 * 学年を選んだらその学年にいるクラスだけを出せるよう、組み合わせを保持する。
 */
export const useSchoolRosterOptions = (schoolId: string | null | undefined) => {
  const [pairs, setPairs] = useState<{ grade: string | null; class: string | null }[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!schoolId) {
      setPairs([])
      return
    }
    let cancelled = false
    setLoading(true)
    UserService.getSchoolGradeClassPairs(schoolId)
      .then(rows => { if (!cancelled) setPairs(rows) })
      .catch(err => {
        console.error('Failed to load grade/class options:', err)
        if (!cancelled) setPairs([])
      })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [schoolId])

  const grades = useMemo(
    () => Array.from(new Set(pairs.map(p => p.grade).filter((g): g is string => !!g))).sort(compareRosterValue),
    [pairs]
  )

  const classesFor = useCallback(
    (grade: string | null) =>
      Array.from(
        new Set(
          pairs
            .filter(p => grade == null || p.grade === grade)
            .map(p => p.class)
            .filter((c): c is string => !!c)
        )
      ).sort(compareRosterValue),
    [pairs]
  )

  return { grades, classesFor, loading }
}
